import React from "react";
import RectangleIcon from "./icons/RectangleIcon";
import CircleIcon from "./icons/CircleIcon";

const ShapePicker = ({
  isActive,
  setIsActive,
  activeProduct,
  setActiveProduct,
}) => {
  return (
    isActive && (
      <div className="configurator-initial">
        <div className="configurator-initial__content">
          <h2 className="marcellus-40-400">Izaberite oblik ploče</h2>
          <div className="configurator-initial__items poppins-18-500">
            <div
              className="configurator-initial__item"
              onClick={() =>
                setActiveProduct((prev) => ({ ...prev, oblik: "Pravougaonik" }))
              }
            >
              <RectangleIcon />
              <div
                className={`configurator-initial__item-button ${
                  activeProduct && activeProduct.oblik == "Pravougaonik"
                    ? "active"
                    : ""
                }`}
              >
                Pravougaonik
              </div>
            </div>
            <div
              className="configurator-initial__item"
              onClick={() =>
                setActiveProduct((prev) => ({ ...prev, oblik: "Krug" }))
              }
            >
              <CircleIcon />
              <div
                className={`configurator-initial__item-button ${
                  activeProduct && activeProduct.oblik == "Krug" ? "active" : ""
                }`}
              >
                Krug
              </div>
            </div>
          </div>
          {activeProduct && activeProduct.oblik && (
            <button
              type="button"
              onClick={() => setIsActive(false)}
              className="configurator-initial__btn btn green"
            >
              Nastavi
            </button>
          )}
        </div>
      </div>
    )
  );
};

export default ShapePicker;
